<template>
  <div class="warning-wrapper" v-if="getshowModule(baseInfo).length > 0 || shownew">
    <a href="#reflashPoint"></a>
    <FTItem class="wrappertop"
    v-for="(item, index) in getshowModule(baseInfo)"
    :content="item"
    :key="index">
    </FTItem>
  </div>
</template>

<script>
import FTItem from '@/components/Fund-Tip-item.vue';
import NativeMsg from '@/base/NativeMsg';
import { mapGetters } from 'vuex';
import FundTypeSearch from '@/utils/FundTypeSearch';
import { setStorage, getStorageSync } from '@fund/storage';

export default {
  name: 'WarningBar',
  props: {
    topSpline: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      baseInfo: 'currentADConDate',
    }),
  },
  components: {
    FTItem,
  },
  data() {
    return {
      showCLick: false,
      contentList: ['根据证监会规定，3月30日起，基金公司将对旗下部分产品持续持有期少于7个自然日的投资者收取不低于1.5%的赎回费，点此了解详情>>>', '策略选基抢占年前最后上车机会策略选基抢占年前最后上车机会'],
      closable: true,
      showIcon: true,
      show: true,
      warn_red_src: '@/assets/warn-tip-red.png',
      close_src: '@/assets/warn-tip-close.png',
      newComf: {
        HotKey: '',
        Id: null,
        Link: {
          LinkType: '2',
          LinkTo: 'https://topic.1234567.com.cn/html/2021/3/18/fkt0318.html?spm=cpyy.JiTianYi.qt&ztcode=fkt0318',
        },
        Mark: null,
        Media: null,
        MediaType: 0,
        Mode: '3',
        ReadDecription: null,
        ReadTitle: '基金详情页全新升级，改版亮点抢先看！',
        ReadType: 0,
        SHOWPOSITION: 0,
        Sort: 0,
        SubHotKey: '',
        SubTitle: '',
        Tip: '',
        Title: '基金详情页全新升级，改版亮点抢先看！',
        UpdateTimeStr: null,
        show: '1',
      },
      newComIndex: 99,
      shownew: false,
    };
  },
  created() {
    this.showMark();
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.handleDefault();
    const mindex = getStorageSync('ef-fund-newtopGui');
    if (mindex !== '1') {
      this.shownew = true;
    } else {
      this.shownew = false;
    }
    NativeMsg.reg('onPageShow', () => {
      this.showPageMark();
    });
  },
  methods: {
    showMark() {
      if (!this.showCLick) {
        this.showCLick = true;
        const { fundCode } = this.$store.state.native.fund;
        const trackLogLTime = window.trackLogTime;
        const now = new Date().getTime();
        let during = now - trackLogLTime;
        if (trackLogLTime === 0) {
          during = 0;
        }
        this.reportMonitor({
          eventName: 'pz50.show',
          infoCode: fundCode,
          loadtime: `${during}`,
          eventContent: {
            loadtime: `${during}`,
          },
        });
      }
    },
    showPageMark() {
      if (!this.showCLick) {
        this.showCLick = true;
        const { fundCode } = this.$store.state.native.fund;
        this.reportMonitor({
          eventName: 'pz50.show',
          infoCode: fundCode,
        });
      }
    },
    render() {
      const mindex = getStorageSync('ef-fund-newtopGui');
      if (mindex !== '1') {
        this.shownew = true;
      } else {
        this.shownew = false;
      }
    },
    setHidView() {
      this.shownew = false;
      setStorage('ef-fund-newtopGui', '1');
    },
    isNewFund() {
      const { fundType } = this.$store.state.native.fund;
      return FundTypeSearch.isNewFund(fundType);
    },
    handleDefault() {},
    clickAction() {

    },
    getshowModule(item) {
      if (item) {
        const { datas } = item;
        if (datas) {
          const { Modules } = datas;
          const ptList = this.getshowListModule(Modules, 'FundDetailNotice');
          return ptList;
        }
      }
      return [];
    },
    getshowListModule(Modules, code) {
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => (item.Title.length > 0)).map((item) => {
            const result = item;
            result.show = '1';
            return result;
          });
          return CustomArray;
        }
      }
      return [];
    },
    getfundAnnouncementList(variInfo, code) {
      if (!variInfo) {
        return [];
      }
      const { Modules } = variInfo;
      if (Modules) {
        const showModules = Modules.filter(
          (item) => (item.ModuleCode === code && item.Items.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { Items } = showModule;
          Items = Items.filter((item) => item.ReadTitle).map((item) => {
            const result = item;
            result.Title = result.ReadTitle;
            result.Mode = '0';
            result.HotKey = '';
            result.SubHotKey = '';
            result.SubTitle = '';
            result.Tip = '';
            result.show = '1';
            return result;
          });
          return Items;
        }
      }
      return [];
    },
    closeWarning() {
      this.show = false;
      this.$emit('closeEvent');
    },
  },
};
</script>

<style scoped lang="less">
.warning-wrapper {
  padding-left: 24px;
  padding-right: 24px;
  align-items: center;
}
.wrapper {
  background: #fff7bc;
  display: flex;
  padding-left: 25px;
  border-radius: 12px;
}

.wrappertop {
  margin-bottom: 24px;
  background: #fff7bc;
  padding-left: 25px;
  border-radius: 12px;
  display: flex;
}

.text-wrapper {
  line-height: 24px;
  flex: 1;
  align-items: center;
}

.content {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #ff4400;
}

.warn_red_img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.close_view {
  width: 50px;
  padding-right: 20px;
  text-align: right;
}

.close_img {
  width: 26px;
  height: 26px;
}
</style>
